import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const loader = () =>
  import(/* webpackChunkName: "4-feat-network-brand-theme-integration" */ './LoadNetworkBrandThemeIntegration').then(
    ({ LoadNetworkBrandThemeIntegration }) => ({
      default: LoadNetworkBrandThemeIntegration,
    })
  );

export const LoadableNetworkBrandTheme = lazyLoadOnRender({ loader });
